import { Card, CardContent, CardHeader, CardTitle } from '@cibli/shared';

import { useBooth } from '../hooks/useBooth';

export function DeviceInfo() {
  const { platformType, status } = useBooth();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Informations matérielles</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <div className="flex justify-between">
          <span className="text-gray-600">Machine ID</span>
          <span className="text-gray-800 font-mono">{status?.system?.deviceId}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Nom du device</span>
          <span className="text-gray-800 font-mono">{status?.system?.deviceName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Fabricant</span>
          <span className="text-gray-800 font-mono">{status?.system?.manufacturer}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Modèle</span>
          <span className="text-gray-800 font-mono">{status?.system?.model}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Type d'appareil</span>
          <span className="text-gray-800 font-mono">{platformType}</span>
        </div>
      </CardContent>
    </Card>
  );
}
